module.exports = __webpack_public_path__ + "static/img/stay-option-icon-convenience.ade5a801.svg";